export default "__VITE_ASSET__CcUyeQwj__"